import { getConfigGeographicPlaceId } from './configGeographicPlaceIds'

export interface TopDestinationLinkItem {
  name: string
  level: string
  alternativeNameForLink?: string
  higherLevel?: string
  country?: string
}

function transformName(name: string): string {
  return name.replace(/-+/g, '+').replace(/\s+/g, '-').toLowerCase()
}

export function getTopDestinationLink(destination: TopDestinationLinkItem): string {
  const placeId = getConfigGeographicPlaceId(destination.name)

  // Keep the destination landing page, but carry the same identity used for
  // its city label. Slug lookups can otherwise resolve the surrounding region.
  const isKnownCity = !!destination.country && !!placeId

  const segments = [
    isKnownCity ? destination.name : (destination.alternativeNameForLink ?? destination.name),
    destination.higherLevel,
    destination.country,
  ].filter((name): name is string => !!name).map(transformName)

  const path = `/hotels/${destination.level}/${segments.join('/')}`
  return isKnownCity ? `${path}?${new URLSearchParams({ destinationId: placeId })}` : path
}
